<script lang="ts" setup>
import { useVModel } from "@vueuse/core"

type Props = {
    modelValue: number
    inputId: string
    label?: string
    hint?: string
    error?: string
    invalid?: boolean
    placeholder?: string
    min?: number
}

const emit = defineEmits(["update:modelValue"])

const props = withDefaults(defineProps<Props>(), {
    inputId: "",
    label: "",
    hint: "",
    error: "",
    invalid: false,
    placeholder: "",
    min: undefined,
})

const modelValue = useVModel(props, "modelValue", emit, {
    eventName: "update:modelValue",
})
</script>
<template>
    <BaseInputWrapper
        class="input-counter"
        :input-id="inputId"
        :label="label"
        :error="error"
        :hint="hint"
    >
        <div class="flex gap-2">
            <BaseInputNumber
                :input-id="inputId"
                :placeholder="placeholder"
                :min="min"
                :invalid="invalid"
                v-model="modelValue"
                class="w-full"
            />
            <div class="flex gap-2">
                <BaseButton
                    icon="pi pi-minus"
                    rounded
                    severity="secondary"
                    :disabled="modelValue <= min"
                    @click="modelValue -= 1"
                />
                <BaseButton
                    icon="pi pi-plus"
                    rounded
                    severity="secondary"
                    @click="modelValue += 1"
                />
            </div>
        </div>
    </BaseInputWrapper>
</template>

<style scoped></style>
